// Core
import React from "react"
import styled from "styled-components"

// Components
import CTALink from "../../../../../../components/CTALink"

// Styles
import colors from "../../../../../../styles/colors"
import size from "../../../../../../styles/size"

// Styles
const Container = styled.div`
  display: flex;
  /* justify-content: space-between; */
  margin: 60px auto 0 auto;

  /* 630px */
  @media (max-width: ${size.laptop}) {
    flex-direction: column;
  }
`

const Location = styled.div`
  color: #000000;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 3.2rem;
  width: 100%;
  /* min-width: 28rem; */
  max-width: 42rem;
  /* height: 1000px; */

  h2 {
    font-size: 1.7rem;
    font-weight: 600;
    color: ${colors["gray-chateau"]};
  }

  h1 {
    font-size: 3rem;
    height: 10rem;
  }

  .address__container {
    /* margin-top: 5rem; */
    font-weight: 600;
    text-align: left;
  }

  .phone__container {
    margin-top: 2.5rem;
    font-weight: 600;
    text-align: left;

    a {
      color: ${colors["picton-blue"]};
    }
  }

  margin-right: 1rem;

  &:last-child {
    margin-right: 0;
  }

  /* 630px */
  @media (max-width: ${size.laptop}) {
    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    margin-top: 5rem;
    margin-right: 0;
  }
`

export default function LocationsContainer() {
  return (
    <Container>
      <Location>
        <h2>CAMPUS</h2>
        <h1>Águas Claras</h1>

        <div className="address__container">
          <div>QS 01, Rua 210, Lote 26</div>
          <div>Águas Claras - DF</div>
          <div>&nbsp;</div>
        </div>

        <div className="phone__container">
          <div>
            <a href="tel:6130480602">(61) 3048-0602</a>
          </div>
        </div>

        <CTALink
          href="https://goo.gl/maps/WEmFk5SjRdZFMyadA"
          target="_blank"
          rel="noopener"
          pictonBlueBG
          lightText
        >
          Abrir no mapa
        </CTALink>
      </Location>

      <Location>
        <h2>CAMPUS</h2>
        <h1>Ceilândia Sul</h1>

        <div className="address__container">
          <div>QNM 05 Conj. P Lote 16</div>
          <div>Ceilândia Sul - DF</div>
          <div>&nbsp;</div>
        </div>

        <div className="phone__container">
          <div>
            <a href="tel:6130480602">(61) 3048-0602</a>
          </div>
        </div>

        <CTALink
          href="https://goo.gl/maps/sQHx2AbFFDx6YBBK8"
          target="_blank"
          rel="noopener"
          pictonBlueBG
          lightText
        >
          Abrir no mapa
        </CTALink>
      </Location>

      <Location>
        <h2>CAMPUS</h2>
        <h1>Águas Lindas</h1>

        <div className="address__container">
          <div>Q 25 LT 01 - Jardim Brasília</div>
          <div>Águas Lindas - GO</div>
          <div>&nbsp;</div>
        </div>

        <div className="phone__container">
          <div>
            <a href="tel:6130480602">(61) 3048-0602</a>
          </div>
        </div>

        <CTALink
          href="https://goo.gl/maps/XPHLrjZGMUQa1yz79"
          target="_blank"
          rel="noopener"
          pictonBlueBG
          lightText
        >
          Abrir no mapa
        </CTALink>
      </Location>

      <Location>
        <h2>CAMPUS</h2>
        <h1>Jardins Mangueiral</h1>

        <div className="address__container">
          <div>Pç de Atividades 5 LT 01</div>
          <div>Jardins Mangueiral - DF</div>
          <div>&nbsp;</div>
        </div>

        <div className="phone__container">
          <div>
            <a href="tel:6130480602">(61) 3048-0602</a>
          </div>
        </div>

        <CTALink
          href="https://goo.gl/maps/AqeG7wGbVE9m9W897"
          target="_blank"
          rel="noopener"
          pictonBlueBG
          lightText
        >
          Abrir no mapa
        </CTALink>
      </Location>


      <Location>
        <h2>CAMPUS</h2>
        <h1>Samambaia Sul</h1>

        <div className="address__container">
          <div>LT 07, QR 116, CONJ. 02</div>
          <div>Samambaia Sul, Brasília - DF</div>
          <div>&nbsp;</div>
        </div>

        <div className="phone__container">
          <div>
            <a href="tel:6130480602">(61) 3048-0602</a>
          </div>
        </div>

        <CTALink
          href="https://goo.gl/maps/N5cfXJe5C28atcKQ8"
          target="_blank"
          rel="noopener"
          pictonBlueBG
          lightText
        >
          Abrir no mapa
        </CTALink>
      </Location>
    </Container>
  )
}
